import apiFetch from '../apiFetch'

export default function (idProducto, token) {
  return apiFetch({endPoint: `Combos/getLotesProductoEspecificoActivoTrazabilidad?idProducto=` + idProducto, method: 'GET', body: null, token: token})
}
